import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import AppPanel from '../fw/AppPanel.react';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import AddButton from '../fw/AddButton.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'apiKeyList.title', 'defaultMessage': 'API Keys'}
});

interface ApiKeyListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class ApiKeyList extends React.Component<ApiKeyListProps> {

    typeName = 'apiKeys';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    render() {
        let { user } = this.props;
        let list = user.apiKeys;
        let type = types[this.typeName];

        /* ugly hack to set organisation_id so we can use our URL mapping system */
        user['organisation_id'] = this.props.user.organisation['realId'];

        /* ugly hack to set organisation_id so we can use our URL mapping system */
        for (let apiKey of list.edges) {
            apiKey.node['organisation_id'] = this.props.user.organisation['realId'];
        }

        return (
            <AppPanel title={this.props.intl.formatMessage(messages.title)} titleAsHeader>
                <div>
                    <PagingGrid
                        columns={['description', 'createdAt']}
                        edges={list}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        parent={this.props.user}
                        relay={this.props.relay}
                        urlMapping={urlMapping} />

                    <AddButton metadata={type} organisationId={this.props.user.organisation.realId} parent={this.props.user} urlMapping={urlMapping} />
                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ApiKeyList), (props) => {
    return props.user;
}), {
    initialVariables: {
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
        organisationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }
        processPagingParams(variables);

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                firstname,
                surname,
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                },
                apiKeys(first: $first, after: $after, before: $before, last: $last) {
                    edges {
                        node {
                            id,
                            user_id,
                            description,
                            createdAt,
                            validFrom,
                            validTo,
                        }
                    },
                    pageInfo {
                        hasNextPage,
                        hasPreviousPage,
                        startCursor,
                        endCursor
                    }
                }
            }
        `,
    },
});
